const SIGNATURE_TYPE_CODES = Object.freeze({
  DIGITAL: 0,
  ELECTRONICA: 1,
});

export const ACCESSIBLE_ORGANIZATION_CODE = "dapd_001";

export const buildResendNotificationPayload = ({
  email,
  cuil,
  signatureType,
  documentId,
  documentName,
  organizationCode,
}) => {
  const signatureTypeCode = SIGNATURE_TYPE_CODES[signatureType];

  if (signatureTypeCode === undefined) {
    throw new Error(`Tipo de firma no soportado: ${signatureType}`);
  }

  const normalizedOrganizationCode = organizationCode?.trim().toLowerCase();
  const payload = {
    destinatarios: [
      {
        email,
        cuil,
        tipoFirma: signatureTypeCode,
      },
    ],
    docId: documentId,
    docName: documentName,
  };

  if (normalizedOrganizationCode === ACCESSIBLE_ORGANIZATION_CODE) {
    payload.codigoOrganismo = ACCESSIBLE_ORGANIZATION_CODE;
  }

  return payload;
};
